import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as Sentry from '@sentry/react';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { datadogRumEnabled, envs } from './lib/constants';
import { scrubUrl } from './lib/scrub-url';

if (envs.ENVIRONMENT !== 'local') {
  Sentry.init({
    dsn: envs.SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2,
    environment: envs.ENVIRONMENT,
    sendDefaultPii: false,
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/api\.local\.dev/,
      /^https:\/\/clientpaydirect\.com/,
    ],
  });
}

if (datadogRumEnabled) {
  datadogRum.init({
    applicationId: envs.DATADOG_APPLICATION_ID,
    clientToken: envs.DATADOG_CLIENT_TOKEN,
    site: envs.DATADOG_SITE || 'datadoghq.com',
    service: 'payee-portal-legacy',
    env: envs.ENVIRONMENT,
    version: envs.APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    sessionPersistence: 'local-storage',
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: envs.DATADOG_PRIVACY_LEVEL,
    plugins: [reactPlugin({ router: true })],
    allowedTracingUrls: envs.API_URL ? [envs.API_URL] : [],
    beforeSend: (event) => {
      event.view.url = scrubUrl(event.view.url);
      if (event.view.referrer) {
        event.view.referrer = scrubUrl(event.view.referrer);
      }
      if (event.type === 'resource') {
        event.resource.url = scrubUrl(event.resource.url);
      }
      if (event.type === 'error' && event.error.resource) {
        event.error.resource.url = scrubUrl(event.error.resource.url);
      }
      return true;
    },
  });
}

// Render the app
const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
